import { useTranslation } from 'react-i18next'

import { Package } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Alert, Text } from '@reveni-io/reveni-ui'

import ShippingMethod from '@/configuration/components/ShippingMethod/ShippingMethod'

const ShippingMethods = ({ shippingMethods, regions, onSelectShippingMethod }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getTitle = () => {
    if (shippingMethods?.length === 1) {
      return `${shippingMethods?.length} ${t('método de envío')}`
    }

    return `${shippingMethods?.length} ${t('métodos de envío')}`
  }

  return (
    <>
      {shippingMethods?.length > 0 ? (
        <>
          <Text
            type="titleS"
            customStyles={{
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing.sp4,
            }}
          >
            <Package size={24} weight="light" /> {getTitle()}:
          </Text>
          {shippingMethods?.map(shippingMethod => (
            <ShippingMethod
              key={shippingMethod.id}
              data={shippingMethod}
              regions={regions}
              isEditable={false}
              showSwitch={false}
              onEdit={() => onSelectShippingMethod(shippingMethod)}
              customBackgroundColor={theme.colors.background.secondary}
              containerPadding={`${theme.spacing.sp8} ${theme.spacing.sp16}`}
            />
          ))}
        </>
      ) : (
        <Alert type="info">{t('Esta ubicación aún no está asociada a ningún método de envío.')}</Alert>
      )}
    </>
  )
}

export default ShippingMethods
